const propertyGridTemplate = document.createElement('template');
const propertyGridTemplateContent = `
<div id="propertyGrid" ></div>
`;
propertyGridTemplate.innerHTML = propertyGridTemplateContent;

export { propertyGridTemplate };
